import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://kexuetang.cn/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20film%20elements%2C%20soft%20golden%20and%20coral%20gradients%2C%20elegant%20curves%2C%20movie%20theater%20atmosphere%2C%20artistic%20motion%20blur%2C%20luxurious%20cinema%20aesthetic%2C%20dark%20rich%20background%20with%20warm%20highlights&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="免费看片平台推荐"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
          免费看片平台推荐
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          汇总2024年最全正版免费看片平台，涵盖电影、电视剧、纪录片、动漫等海量资源，
          无需付费即可享受高清画质，安全合规、无广告骚扰，助你随时随地轻松追剧看电影。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianying"
            className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
          </Link>
          <Link
            to="/about"
            className="border border-white/40 hover:border-white/80 text-white px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}